import React from 'react'
import EmptyState from '../EmptyState/EmptyState.component'
import type { SelectableCardGridProps } from './SelectableCard.types'
import './SelectableCard.css'

const DEFAULT_EMPTY_TITLE = 'No items to display'
const DEFAULT_EMPTY_DESCRIPTION = "There's no data to show here"

const SelectableCardGrid: React.FC<SelectableCardGridProps> = ({
  children,
  minColumnWidth = 288,
  maxHeight,
  emptyMessage,
  emptyState,
  className = '',
  darkMode = false,
}) => {
  const childArray = React.Children.toArray(children).filter(Boolean)
  const isEmpty = childArray.length === 0

  const classNames = [
    'ds-selectable-card-grid',
    darkMode ? 'ds-selectable-card-grid--dark' : '',
    isEmpty ? 'ds-selectable-card-grid--empty' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  const style: React.CSSProperties = {
    ['--ds-selectable-card-grid-min' as string]: `${minColumnWidth}px`,
  }

  if (maxHeight != null) {
    style.maxHeight =
      typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight
    style.overflowY = 'auto'
  }

  const resolvedTitle = emptyState?.title ?? emptyMessage ?? DEFAULT_EMPTY_TITLE
  const resolvedDescription =
    emptyState?.description ??
    (emptyMessage != null && emptyState == null
      ? undefined
      : DEFAULT_EMPTY_DESCRIPTION)
  const showAction = Boolean(emptyState?.actionLabel && emptyState?.onAction)
  const emptyClassName = [
    'ds-selectable-card-grid__empty',
    maxHeight != null ? 'ds-selectable-card-grid__empty--compact' : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classNames} style={style}>
      {isEmpty ? (
        <EmptyState
          className={emptyClassName}
          title={resolvedTitle}
          description={resolvedDescription}
          actionLabel={showAction ? emptyState?.actionLabel : undefined}
          onAction={emptyState?.onAction}
          darkMode={darkMode}
        />
      ) : (
        childArray
      )}
    </div>
  )
}

export default SelectableCardGrid
